import MyServicesV1 from './v1';
import MyServicesV2 from './v2';

// Default export - new modern version
export default MyServicesV2;

// Named exports for specific versions
export { MyServicesV1, MyServicesV2 };